<template>
  <div>
    <h1>Game List</h1>
    <div><button @click="addNewGame">Add Game</button></div>
    <div>
      <!--  -->
      <table>
        <thead>
          <tr>
            <th>Game Name</th>
            <th>ID</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(game, i) in gameList" :key="i">
            <td>{{ game.name }}</td>
            <td>{{ game.id }}</td>
            <td>
              <span class="coding-edit-span-button link" @click="editGame(game)"
                >edit</span
              >
              <span
                class="coding-delete-span-button link"
                @click="deleteGame(game)"
                >X</span
              >
            </td>
          </tr>
        </tbody>
      </table>
      <!--  -->
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      gameList: [],
    }
  },
  mounted() {
    this.populateGameList()
  },
  methods: {
    deleteGame(game) {
      this.axios({
        method: "delete",
        url: `${siteConfig.siteURL}questions/${game.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.populateGameList()
      })
    },
    editGame(game) {
      this.$router.push(`/game-edit/${game.id}`)
    },
    addNewGame() {
      this.$router.push("/game-add/")
    },
    populateGameList() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}questions/type/game`,
        data: this.gameObj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.gameList = res.data.data
      })
    },
  },
}
</script>
